var _path, _path2, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyExternal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.8,60.14h-10.39c-.55,0-1-.45-1-1s.45-1,1-1h8.35l-2.04-2.63c-.34-.44-.26-1.06.18-1.4.44-.34,1.07-.26,1.4.18l3.29,4.25c.23.3.28.71.11,1.05-.17.34-.52.56-.9.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.7,71.09c-.3,0-.59-.13-.79-.39l-3.29-4.25c-.23-.3-.28-.71-.11-1.05.17-.34.52-.56.9-.56h10.39c.55,0,1,.45,1,1s-.45,1-1,1h-8.35l2.04,2.63c.34.44.26,1.06-.18,1.4-.18.14-.4.21-.61.21Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.22,99.46h-30.22c-.55,0-1-.45-1-1V25.05c0-.45.31-.85.75-.97l30.22-7.96c.3-.08.62-.01.87.18.25.19.39.48.39.79v81.36c0,.55-.45,1-1,1ZM62,97.46h28.22V18.39l-28.22,7.43v71.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.85,34.07h-17.48c-.55,0-1-.45-1-1s.45-1,1-1h17.48c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.85,41.43h-17.48c-.55,0-1-.45-1-1s.45-1,1-1h17.48c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.85,48.78h-17.48c-.55,0-1-.45-1-1s.45-1,1-1h17.48c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.85,56.14h-17.48c-.55,0-1-.45-1-1s.45-1,1-1h17.48c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.85,63.49h-17.48c-.55,0-1-.45-1-1s.45-1,1-1h17.48c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.85,70.84h-17.48c-.55,0-1-.45-1-1s.45-1,1-1h17.48c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.85,78.2h-17.48c-.55,0-1-.45-1-1s.45-1,1-1h17.48c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.85,85.55h-17.48c-.55,0-1-.45-1-1s.45-1,1-1h17.48c.55,0,1,.45,1,1s-.45,1-1,1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.91,99.46H7.68c-.55,0-1-.45-1-1V.75c0-.55.45-1,1-1h30.22c.55,0,1,.45,1,1v97.7c0,.55-.45,1-1,1ZM8.68,97.46h28.22V1.75H8.68v95.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.33,33.93H14.26c-.55,0-1-.45-1-1s.45-1,1-1h17.07c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.33,41.08H14.26c-.55,0-1-.45-1-1s.45-1,1-1h17.07c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.33,48.22H14.26c-.55,0-1-.45-1-1s.45-1,1-1h17.07c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.33,12.5H14.26c-.55,0-1-.45-1-1s.45-1,1-1h17.07c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.33,19.64H14.26c-.55,0-1-.45-1-1s.45-1,1-1h17.07c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.33,26.79H14.26c-.55,0-1-.45-1-1s.45-1,1-1h17.07c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.33,55.37H14.26c-.55,0-1-.45-1-1s.45-1,1-1h17.07c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.33,62.51H14.26c-.55,0-1-.45-1-1s.45-1,1-1h17.07c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.33,69.66H14.26c-.55,0-1-.45-1-1s.45-1,1-1h17.07c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.33,76.8H14.26c-.55,0-1-.45-1-1s.45-1,1-1h17.07c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.33,83.95H14.26c-.55,0-1-.45-1-1s.45-1,1-1h17.07c.55,0,1,.45,1,1s-.45,1-1,1Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.87,
    y1: 98.46,
    x2: 98.34,
    y2: 98.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.34,99.46H.87c-.55,0-1-.45-1-1s.45-1,1-1h97.47c.55,0,1,.45,1,1s-.45,1-1,1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyExternal);
export default __webpack_public_path__ + "static/media/Company External.e654280838bd76b73a686b93ef4363ef.svg";
export { ForwardRef as ReactComponent };